import { atomWithStorage } from 'jotai/utils';
import { VIEW_OPTIONS } from 'pages/RunOrchestration/RunOrchestrations.constants';

// Persists the "View only Active" switch on the Run Orchestrations banner to
// localStorage, so the toggle survives page reloads/navigating away and back
// - mirroring the persisted dashboard atoms in `pages/NewDashboard/atoms.ts`.
// Reset on logout via `useResetRunOrchestrationBanner` (see App.tsx/HeaderCsb.tsx)
// so a new session doesn't inherit a previous user's/session's choice.
export const isViewingOnlyActiveOrchestrationsAtom = atomWithStorage<boolean>(
  'run-orchestrations-view-only-active',
  false
);

// Persists the selected List/Split/Column view so it survives page reloads/
// navigating away and back, same rationale as the switch above.
export const selectedRunOrchestrationViewAtom = atomWithStorage<VIEW_OPTIONS>(
  'run-orchestrations-selected-view',
  VIEW_OPTIONS.LIST_VIEW
);

